const getPipeHeaderConfig = (variant) => {
  const variantsConfigs = {
    defaultConfig: [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "L1 Primary": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "Primary Applovin": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "Water Fasting": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "L3 Primary": [
      {
        titleKey: "goal_setting",
        steps: [
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/", skipCount: true },
          { path: "/stepName/" },
          { path: "/stepChangingEatingHabits/" },
          { path: "/stepStayOnTrack/", skipCount: true },
          { path: "/stepHealthyLifestyleInterests/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepExpertQuote/", skipCount: true },
          { path: "/stepEasyToFollow/", skipCount: true },
          { path: "/stepBodyType/", completed: true  },
        ],
      },
      {
        titleKey: "my_eating_habits",
        steps: [
          { path: "/stepMealCount/" }, 
          { path: "/stepMealOfTheDay/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepRecipesIntro/", completed: true },
        ],
  
      },
      {
        titleKey: "my_lifestyle",
        steps: [
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/", skipCount: true },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/", skipCount: true },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepEncouragementSleep/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/", completed: true }
        ],
      },
      {
        titleKey: "my_health_and_motivation",
        steps: [
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/", completed: true },
          { path: "/stepPlanGeneration/", skipCount: true },
        ],
      }
    ],
    "WF Discount Code": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
          { path: "/stepRevealDiscount/" },
        ],
      }
    ],
    "WF Discount Code+ KB assist": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
          { path: "/stepRevealDiscount/" },
        ],
      }
    ],
    "L Refreshed Design": [
      {
        steps: [
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepPhysicalBuild/" },
          { path: "/stepPreferredBodyType/" },
          { path: "/stepSocialProofWithReviews/", skipCount: true },
          { path: "/stepChangingEatingHabits/" },
          { path: "/stepStayOnTrack/", skipCount: true },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/", skipCount: true },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealRhythm/", skipCount: true },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepJunkFoodHabits/" },
          { path: "/stepMealDistractions/" },
          { path: "/stepHabitDiscipline/" },
          { path: "/stepSocialProofWithTestimonial/", skipCount: true },
          { path: "/stepEasyToFollow/", skipCount: true },
          { path: "/stepWhatYouGet/", skipCount: true },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/", skipCount: true },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/", skipCount: true },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/", skipCount: true },
          { path: "/stepUpdatedProjectedProgressGraph/", skipCount: true },
          { path: "/stepPlanGeneration/", skipCount: true },
          { path: "/stepName/", skipCount: true },
          { path: "/stepEmailCapture/", skipCount: true },
          { path: "/stepRhetoricalQuestion1/", skipCount: true },
          { path: "/stepRhetoricalQuestion2/", skipCount: true },
          { path: "/stepRhetoricalQuestion3/", skipCount: true },
          { path: "/stepEncouragementAllSet/", skipCount: true },
          { path: "/stepPersonalCommitment/", skipCount: true },
          { path: "/stepResultsProgressGraph/", skipCount: true },
          { path: "/stepResultsBmi/", skipCount: true },
          { path: "/stepResultsHealthImprovements/", skipCount: true },
          { path: "/stepResultsSocialProofAndGuidance/", skipCount: true },
          { path: "/stepResultsStartNow/", skipCount: true },
          { path: "/stepRevealDiscount/", skipCount: true },
        ],
      }
    ]
  }

  return variantsConfigs[variant] || variantsConfigs.defaultConfig
}

export default getPipeHeaderConfig
